import React, { useEffect } from 'react'
import LandingHero from '../components/LandingHero'
import BestChoiceSection from '../components/BestChoiceSection'
import SoGehtBestpreisSection from '../components/SoGehtBestpreisSection'
import FaqSection from '../components/FaqSection'
import BenefitsMapSection from '../components/BenefitsMapSection'
import TestimonialsSection from '../components/TestimonialsSection'
import FooterSection from '../components/FooterSection'
import { setupLandingPage } from '../lib/landingAnimations'
import { setupTabs } from '../lib/tabLogic'

const HomePage = () => {
  useEffect(() => {
    const teardown = setupLandingPage()
    const teardownTabs = setupTabs()

    return () => {
      teardown?.()
      teardownTabs?.()
    }
  }, [])

  return (
    <div
      className="brand-fonts relative min-h-screen bg-white"
    >
      <LandingHero />
      <BestChoiceSection />
      <SoGehtBestpreisSection />
      <FaqSection />
      <BenefitsMapSection />
      <TestimonialsSection />
      <FooterSection />
    </div>
  )
}

export default HomePage
